import { Col } from 'reactstrap';
import { H3 } from '../../../../../AbstractElements';
import DollarInput from '../../../../common/DollarInput';
import { useLocation } from 'react-router-dom';
import { useGetRequestQuery } from '../../../../../Hooks/useGetRequestQuery';
import { getAssetsAndLiabilitiesByClientId, updateAssetsAndLiabilitiesService } from '../../../../../Services/MMPClientServices/AssetsAndLiabilitiesService';
import { useEffect, useState } from 'react';
import { useMutationRequestQuery } from '../../../../../Hooks/useMutationRequestQuery';
import { toast } from 'react-toastify';
import { assetsOtherFormData } from '../../../Public/FormData';

export default function FactFindAssetsOther({ clientId }: any) {
    const [formData, setFormData] = useState<any>(assetsOtherFormData)
    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const location = useLocation();
    const isMMPAssetsLiabilitiesRoute = location.pathname === '/MMPAssetsLiabilities';

    const {
        data: assetsAndLiabilitiesResponse,
        refetch: refetchAssetsAndLiabilities,
        isLoading: isAssetsAndLiabilitiesLoading,
        isError: isAssetsAndLiabilitiesError,
    } = useGetRequestQuery<any>(
        ['getAssetsAndLiabilitiesByClientId', clientId],
        () => getAssetsAndLiabilitiesByClientId(clientId as any),
        {
            enabled: !!clientId,
        }
    );

    useEffect(() => {
        if (assetsAndLiabilitiesResponse?.data && !isAssetsAndLiabilitiesError && !isAssetsAndLiabilitiesLoading && typeof assetsAndLiabilitiesResponse.data === 'object') {
            setFormData(assetsAndLiabilitiesResponse?.data);
        }
    }, [assetsAndLiabilitiesResponse, isAssetsAndLiabilitiesError, isAssetsAndLiabilitiesLoading]);

    const { mutate: updateClientAssets } = useMutationRequestQuery(
        'updateAssetsAndLiabilitiesService',
        updateAssetsAndLiabilitiesService,
        {
            onSuccess: (data: any) => {
            },
            onError: (error: any) => {
                toast.error('Failed to submit Assets and Liabilities information');
            },
        }
    );

    const handleHover = () => {
        updateClientAssets({ ...formData, clientId: clientId });
    };


    return (
        <div className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'} onBlur={handleHover}>
            <div className="table-responsive h-100 py-4">
                <section className='bg-white'>

                    <div className="scrollable-table-container">
                        <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                            <div className="d-flex align-items-center">
                                <Col xs={12} className='d-flex'>
                                    <H3 className="heading-color f-w-900 text-left my-2">Assets Other</H3>
                                </Col>
                            </div>
                            <div className='d-flex flex-wrap item-center mt-2'>
                                <Col className="responsive-col mb-3" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                    Cash & Savings
                                </Col>
                                <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                    <DollarInput
                                        label=""
                                        name="otherAssetsCashAndSavings"
                                        value={formData.otherAssetsCashAndSavings}
                                        setValue={handleValueChange}
                                        limit={8}
                                        tabIndex={82}
                                        design="flex"
                                        passCol='col-10'

                                    />
                                </Col>

                                <Col className="responsive-col mb-3" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                    Super Applicant 1
                                </Col>
                                <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                    <DollarInput
                                        label=""
                                        name="superApplicant1"
                                        value={formData.superApplicant1}
                                        setValue={handleValueChange}
                                        limit={8}
                                        design="flex"
                                        tabIndex={83}
                                        passCol='col-10'

                                    />
                                </Col>

                                <Col className="responsive-col mb-3" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                    Super Applicant 2
                                </Col>
                                <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                    <DollarInput
                                        label=""
                                        name="superApplicant2"
                                        value={formData.superApplicant2}
                                        setValue={handleValueChange}
                                        limit={8}
                                        design="flex"
                                        tabIndex={84}
                                        passCol='col-10'

                                    />
                                </Col>

                                <Col className="responsive-col mb-3" xs={12} style={{ width: '3.4%', paddingInline: '2px' }}>
                                    SMSF
                                </Col>
                                <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                    <DollarInput
                                        label=""
                                        name="smsf"
                                        value={formData.smsf}
                                        setValue={handleValueChange}
                                        limit={8}
                                        design="flex"
                                        tabIndex={85}
                                        passCol='col-10'
                                    />
                                </Col>
                            </div>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}
